import styled from 'styled-components/macro';

type CanvasWrapperProps = {
  backgroundColor: string;
};

export const CanvasWrapper = styled.div<CanvasWrapperProps>`
  background: ${({ backgroundColor }) => backgroundColor};
  width: 800px;
  height: 800px;
  color: white;
  box-sizing: border-box;
`;
